<template>
	<div class="field">
		<div class="container">
			<div class="content">
				<div class="field-inner">
					<label :for="`core-${name}-0`">
						<span class="info" :data-tooltip="$t('core-help')">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M8.1 4.5h1.8v1.8H8.1zm0 3.6h1.8v5.4H8.1zm.9 8.1A7.2 7.2 0 1 1 16.2 9 7.22 7.22 0 0 1 9 16.2zM9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9z"/></svg>
						</span>
						<slot name="title">{{$t('core')}}</slot>
					</label>
					<div
						class="element"
						v-for="(field, index) in fields"
						:key="'field-' + index"
					>
						<div class="flex" data-cols="2">
							<select @change="update(field, $event)" :value="field.yarnCount.code">
								<option
									v-for="(unit, index2) in $yarnCountUtils.units"
									:key="'unit-'+index2"
									:value="unit.code"
								>
									{{$t(unit.name)}}
								</option>
							</select>
							<input type="number" :placeholder="$t('yarn-count')" min="0" step="any" v-model="field.yarnCount.value" :id="`core-${name}-${index}`">
						</div>
						<span class="add-more remove" v-show="fields.length > min" @click="remove(field)">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 16.2A7.2 7.2 0 1 1 16.2 9 7.22 7.22 0 0 1 9 16.2zm-.9-6.3H4.5V8.1h9v1.8H8.1z"/></svg>
						</span>
					</div>
					<span class="add-more add" @click="add()" v-show="fields.length < max">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path  d="M9,16.2A7.2,7.2,0,1,1,16.2,9,7.22,7.22,0,0,1,9,16.2ZM9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0Zm.9,4.5H8.1V8.1H4.5V9.9H8.1v3.6H9.9V9.9h3.6V8.1H9.9Z"/></svg>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Core',
	props: ['min', 'max', 'fields', 'name'],
	methods: {
		update(field, event) {
			field.yarnCount = {...this.$yarnCountUtils.select(event.target.value), value: field.yarnCount.value};
		},
		add() {
			if (this.fields.length < this.max) {
				let field = {
					yarnCount: {...this.$yarnCountUtils.select(this.$settings.data.defaultYarnCount), value: ''}
				};
				this.$set(this.fields, this.fields.length, field);
			}
		},
		remove(field) {
			if (this.fields.length > this.min) {
				this.$delete(this.fields, this.fields.indexOf(field));
			}
		}
	}
}
</script>